import React, { useState, useRef, useEffect } from "react";
import moment from "moment";

type SearchProps = {
  searchViewObject: any;
  searchSubmitHandeler: Function;
  changeHandler: Function;
  clearFilter: Function;
};
function SearchView(props: SearchProps) {
  return (
    
      <div className="flex-da gap-10 grid-sm2">
        {props.searchViewObject.ColumnNames.map(
          (ColumnNames: any, index: any) => {
            if (ColumnNames.DataType === "FK" && ColumnNames.IsSearchable) {
              return (
                <>
                  {ColumnNames.FKColumnName.map(
                    (FKColumnNames: any, FKindex: any) => (
                      <div key={FKindex} className=" ">
                        <span className="no-display">{FKColumnNames.Name}</span>
                        <div className="field-input">
                        <select
                          className="input-field width-auto"
                          // defaultValue={
                          //   this.state[FKColumnNames.ActualColumnName]
                          // }
                          name={FKColumnNames.ActualColumnName}
                          onChange={(e) => props.changeHandler(e)}
                        >
                          <option value="">Please Select</option>
                          {props.searchViewObject.ForeignKeysData[0] &&
                            props.searchViewObject.ForeignKeysData[0][
                              FKindex
                            ] &&
                            props.searchViewObject.ForeignKeysData[0][
                              FKindex
                            ].map((FKItem: any, FKItemIndex: any) => (
                              <option key={FKItem.PID} value={FKItem.PID}>
                                {FKItem.Name}
                              </option>
                            ))}
                        </select>
                        </div>
                      </div>
                    )
                  )}
                </>
              );
            }

            if (ColumnNames.DataType === "int" && ColumnNames.IsSearchable) {
              return (
                <div key={index} className=" ">
                  <span className="no-display">{ColumnNames.Name}: </span>
                  <div className="field-input">
                  <input
                    className="input-field width-auto"
                    type="number"
                    placeholder={ColumnNames.Name}
                    name={ColumnNames.ActualColumnName}
                    value={props.searchViewObject.ColumnNames.ActualColumnName}
                    onChange={(e) => props.changeHandler(e)}
                  />
                  </div>
                </div>
              );
            }
            if (
              (ColumnNames.DataType === "nvarchar" ||
                ColumnNames.DataType === "nvarcharMax") &&
              ColumnNames.IsSearchable
            ) {
              return (
                <div key={index} className=" ">
                  <span className="no-display">{ColumnNames.Name}: </span>
                  <div className="field-input">
                  <input
                    className="input-field width-auto"
                    type="text"
                    placeholder={ColumnNames.Name}
                    name={ColumnNames.ActualColumnName}
                    value={props.searchViewObject.ColumnNames.ActualColumnName}
                    onChange={(e) => props.changeHandler(e)}
                  />
                  </div>
                </div>
              );
            }
            if (
              ColumnNames.DataType === "datetime" &&
              ColumnNames.IsSearchable
            ) {
              return (
                <div key={index} className=" ">
                  <span className="no-display">{ColumnNames.Name}: </span>
                  <div className="field-input"> 
                  <input
                    className="input-field width-auto"
                    type="date"
                    name={ColumnNames.ActualColumnName}
                    value={props.searchViewObject.ColumnNames.ActualColumnName}
                    onChange={(e) => props.changeHandler(e)}
                  />
                  </div>
                </div>
              );
            }
            if (
              ColumnNames.DataType === "boolean" &&
              ColumnNames.IsSearchable
            ) {
              return (
                <div key={index} className=" ">
                  <span className="no-display">{ColumnNames.Name}: </span>
                  <div className="field-input">
                    <input
                      className="input-field width-auto"
                      type="checkbox"
                      name={ColumnNames.ActualColumnName}
                      value={
                        props.searchViewObject.ColumnNames.ActualColumnName
                      }
                      checked={
                        props.searchViewObject.ColumnNames.ActualColumnName
                      }
                      onChange={(e) => props.changeHandler(e)}
                    />
                  </div>
                </div>
              );
            }
          }
        )}
        <div className="flex-daj btn-start flex-gap10">
          <a
            type="submit"
            className="btn-primary flex-daj"
            // onClick={(e) => props.searchSubmitHandeler(e, true, true)}
          >
            Search
          </a>
          <a onClick={(e) => props.clearFilter(e)} className="btn-primary flex-daj">
            Clear Filter
          </a>
        </div>
      </div>
  );
}

export default SearchView;
